const ITEMS = [
  "Fiorentina su ghisa",
  "Vicini di vigna",
  "Frollature ricercate",
  "Centro storico di Follonica",
  "Cene che durano",
];

const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative overflow-hidden border-y border-[#C5A059]/15 bg-[#141210] py-5 select-none"
    aria-hidden="true"
  >
    <div className="flex w-max animate-marquee gap-0">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex shrink-0 items-center">
          {ITEMS.map((item) => (
            <span key={`${copy}-${item}`} className="flex items-center">
              <span className="font-display italic text-lg sm:text-xl text-[#C5BCAD]/80 px-8 whitespace-nowrap">
                {item}
              </span>
              <span className="w-1.5 h-1.5 rotate-45 bg-[#C5A059]/60" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
